import { HumanizePipe } from '@shared/pipes/humanize.pipe';
import { RestTemplateModel } from '@template/models/rest-template-model.interface';

import { InspectionAreaModel } from './inspection-area.model';
import { InspectionStepModel } from './inspection-step.model';
import { InspectionStatus, InspectionType, RestInspectionsModel } from './rest-inspections-model.interface';

export declare type PropertyState = 'good' | 'fair' | 'poor' | 'skipped' | undefined;

export class InspectionModel {
  readonly id: number;
  readonly completedOrSkippedAreasCount: number;
  readonly areasCount: number;
  readonly title: string;
  readonly status: string;
  readonly inspectionType: string;
  readonly areas: InspectionAreaModel[];

  readonly summary: { [key: string]: number } = { flagsCount: 0 };
  readonly allSteps: InspectionStepModel[];
  readonly propertyId: number;
  readonly portfolioId: number;
  readonly unitName: string;
  readonly propertyName: string;

  constructor(
    public readonly entityDetails: RestInspectionsModel,
    public readonly inspectionTemplate: RestTemplateModel
  ) {
    this.id = entityDetails.id;
    this.inspectionType =
      entityDetails.inspectionType != null
        ? HumanizePipe.transform(InspectionType[entityDetails.inspectionType])
        : 'Inspection';
    this.title = `${this.inspectionType} - ${entityDetails.unit.name}`;
    this.status = HumanizePipe.transform(InspectionStatus[entityDetails.status]);
    this.propertyId = entityDetails.unit?.propertyId;
    this.portfolioId = entityDetails.unit?.property?.portfolioId;
    this.unitName = entityDetails?.unit?.name;
    this.propertyName = entityDetails?.unit?.property?.name;

    if (entityDetails?.inspectionContents.length) {
      this.areas = entityDetails.inspectionContents.map(content => new InspectionAreaModel(content));
      this.allSteps = this.areas.flatMap(area => area.steps).filter(Boolean);
      this.areasCount = this.areas.length;

      this.completedOrSkippedAreasCount = this.areas.filter(area => area.isCompleted || area.isSkipped).length;
      this.allSteps.reduce((acc, curStep) => {
        acc[curStep.propertyState] = (acc[curStep.propertyState] ?? 0) + 1;
        acc.notesCount = (acc.notesCount ?? 0) + (curStep.note ? 1 : 0);
        return acc;
      }, this.summary);
    } else {
      this.completedOrSkippedAreasCount = entityDetails.completedRooms;
      this.areasCount = entityDetails.totalRooms;
    }
  }

  get areasLabel() {
    return `${this.completedOrSkippedAreasCount}/${this.areasCount}`;
  }
}
